module.exports = __webpack_public_path__ + "static/media/custom-template.196317fd.png";